__turbopack_context__.v({
  "cornerRibbon": "CornerBanner-module-scss-module__sas8wa__cornerRibbon",
});
